import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";

@usingJsonToModelConvertor
export default class LatLong extends Model{

    @fromJsonObject({key: 'lat'})
    public lat! : number;

    @fromJsonObject({key: 'long'})
    public long! : number;

    public toString():string{
        return `[${this.lat},${this.long}]`
    }

    public toObject():object{
        return {
            lat: this.lat,
            long: this.long
        }
    }

    public toArray():number[]{
        return [
            this.lat, this.long
        ];
    }

}